import { useStudioStore } from '@/store/useStudioStore';
import { cn } from '@/lib/utils';
import { Icon } from '@iconify/react';
import { trackStudioEvent } from '@/lib/studioTracking';

/** 版本历史触发按钮组件 */
export const StudioVersionButton = () => {
  const isBuilding = useStudioStore((state) => state.isBuilding);
  const isHistoryOpen = useStudioStore((state) => state.isHistoryOpen);
  const toggleHistory = useStudioStore((state) => state.toggleHistory);
  const isPreviewReviewActive = useStudioStore((state) => state.previewReview.active);
  const historyItemCount = useStudioStore((state) => state.historyItems.length);
  const currentProjectTypeId = useStudioStore((state) => state.currentProjectTypeId);
  const isDisabled = (isBuilding ?? false) || isPreviewReviewActive;
  const pendingReviewTooltip = 'Accept or keep the latest change first.';

  const handleToggleHistory = () => {
    if (!isHistoryOpen) {
      trackStudioEvent('studio_version_history_open', {
        entrySource: 'version_button',
        historyItemCount,
        hasPendingReview: isPreviewReviewActive,
        projectTypeId: currentProjectTypeId,
      });
    }
    toggleHistory();
  };

  return (
    <div className="group/version relative">
      <button
        title={
          isPreviewReviewActive
            ? 'Version history is unavailable while a draft review is pending.'
            : 'Version History'
        }
        disabled={isDisabled}
        onClick={handleToggleHistory}
        className={cn(
          'text-muted-foreground/60 hover:text-foreground flex h-[36px] w-[36px] cursor-pointer items-center justify-center rounded-[9px] border border-black/5 bg-white text-[14px] transition-all hover:border-[rgba(109,40,217,0.3)] hover:bg-[rgba(109,40,217,0.05)] hover:text-[#6D28D9] disabled:cursor-default disabled:opacity-40',
          isHistoryOpen && 'border-[#6D28D9]/30 bg-[#6D28D9]/5 text-[#6D28D9]',
        )}
      >
        <Icon icon="fa6-solid:clock-rotate-left" />
      </button>
      {isPreviewReviewActive && (
        <div className="pointer-events-none absolute top-[calc(100%+8px)] right-0 z-[160] w-max max-w-[220px] rounded-[10px] bg-[#0D0D1A] px-[10px] py-[7px] text-[11.5px] leading-[1.45] font-medium whitespace-normal text-white opacity-0 shadow-[0_12px_28px_rgba(15,23,42,0.22)] transition-opacity duration-150 group-hover/version:opacity-100">
          {pendingReviewTooltip}
        </div>
      )}
    </div>
  );
};
